<template>
  <div class="grid-container " :class="{'grid-container__joker': unit === gUnit.joker}" v-if="methods.length && customerShopPackages.length">
    <div class="buy-credits__payment">

      <div class="payment-wrapper">
        <label
          v-for="(method, index) in methods" :key="method.id"
          :class="{'mobile-centered': index%2===0 && index === methods.length-1}"
        >
          <input v-model="methodId" name="payment_method" type="radio" class="radio__icon" :value="method.id">
          <a
            v-show="method.id !== methodId"
            class="button button__icon-flex button__icon-image not-active-method"
            :title="method.name"
            v-html="method.image_inactive"
          >
          </a>
          <a
            v-show="method.id === methodId"
            class="button button__icon-flex button__icon-image active-method"
            :title="method.name"
            v-html="method.image"
          >
          </a>
        </label>
      </div>
      <voucher v-model="voucherData" :unit="unit"></voucher>
    </div>

    <!--        Title header-->
    <!--        <div class="buy-credits__title-header title title&#45;&#45;small" v-if="unit === gUnit.coin">{{ trans.get('ms:shop.coins_package') }}</div>-->
    <!--        <div class="buy-credits__title-header title title&#45;&#45;small" v-if="unit === gUnit.joker">{{ trans.get('ms:shop.joker_package') }}</div>-->
    <div class="buy-credits__items">
      <template v-for="shopPackage in customerShopPackages">
        <transition name="fade">
          <PackageElement
            :key="shopPackage.id"
            :shopPackage="shopPackage"
            :fee="currentMethod.fee"
            @buy="buy"
            :voucher="voucherData ? {discount: voucherData.discount, type: voucherData.type} : null"
          >
          </PackageElement>
        </transition>
      </template>
    </div>
  </div>
</template>

<script>
import PackageElement from './PackageElement';
import Voucher from './Voucher';
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentComponent',
  components: { Voucher, PackageElement },
  props: {
    unit: {
      type: String,
      required: true,
      validator: function (value) {
        return ['coin', 'joker'].indexOf(value) !== -1;
      }
    },
  },
  data() {
    return {
      methods: [],
      methodId: null,
      voucherData: null,
      gUnit: {
        coin: window.globals.customer_shop_package.unit_coin,
        joker: window.globals.customer_shop_package.unit_joker,
      }
    };
  },
  computed: {
    currentMethod: function () {
      if (this.methodId) {
        return this.methods.find((el) => el.id === this.methodId);
      }
      return null;
    },
    customerShopPackages: function () {
      if (this.currentMethod) {
        return this.currentMethod.customer_shop_packages.sort((a, b) => a.price > b.price ? 1 : -1);
      }
      return [];
    },
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  watch: {},
  methods: {
    fetchData: function () {
      axios
        .get(zRoute('ajax.payment.index', {
          unit: this.unit,
          service: 'WEB',
        }))
        .then((response) => {
          this.methods = response.data.data;
          if (this.methodId === null)
            this.methodId = this.methods[0].id;
        });
    },
    buy: function ({ package_id, price }) {
      axios
        .post(zRoute('ajax.payment.store'), {
          customer_shop_package_id: package_id,
          price: price,
          payment_method_id: this.methodId,
          voucher_id: this.voucherData ? this.voucherData.id : null,
        })
        .then((response) => {
          localStorage.setItem('last_payment_price', price);
          window.location.href = response.data.redirect_url;
        })
        .catch((error) => {
          // show notification
          this.$notify({
            group: 'custom-template',
            type: 'error',
            title: 'Error',
            text: error.response.data.message,
            duration: 5000,
            data: {},
          });
        });

      this.$store.dispatch('analytics/gtagEvent', {
        event: 'purchase',
        p: {
          'event_category': 'Shop',
          'event_label': 'Initiate purchase',
          'package': package_id,
          'method': this.methodId,
          'value': price
        }
      });
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
